import React from 'react'
import useCloseButtonTop from '../../../hooks/useCloseButtonTop'
import { useUtilsStore } from '../../Contexts/UtilsContext'
import { useRetorikStore } from '../../Contexts/RetorikContext'
import { useLocaleStore } from '../../Contexts/LocaleContext'
import { CurrentSubView, UIPart } from '../../../models/enums'
import { Dashboard as OldDashboard } from '../Common'
import Dashboard from '../../Menus/Large/Dashboard'
import DashboardButton from './DashboardButton'
import Remote from './Remote'

const RemoteContainer = ({ hideMenu = false }): JSX.Element => {
  const top = useCloseButtonTop()
  const menu = useRetorikStore((state) => state.configuration.menu)
  const dashboardOpened = useUtilsStore((state) => state.dashboardOpened)
  const isRTL = useLocaleStore((state) => state.isRTL)
  const { setCurrentSubView, setDashboardOpened, setClickedOnUI } = useUtilsStore((state) => state.actions)

  /**
   * On call :
   *  - close subview if one is opened and if the parameter is false / undefined
   *  - toggle dashboardOpened state
   * @param doNotCloseViews : boolean
   */

  const toggleDashboard = (doNotCloseViews?: boolean): void => {
    !doNotCloseViews && setCurrentSubView(CurrentSubView.none)
    setDashboardOpened(!dashboardOpened)
  }

  const handleClick = (e: React.MouseEvent): void => {
    setClickedOnUI(UIPart.remote)
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <React.Fragment>
      <div
        className={`rf-absolute rf-z-ui rf-hidden large:rf-flex rf-flex-col rf-items-center rf-justify-start rf-w-24 rf-right-0 ${isRTL ? 'rf-text-arabic' : 'rf-text-xsm'} rf-text-trueblack`}
        style={{
          top: top
        }}
        onClick={(e) => handleClick(e)}
      >
        {/* Dashboard button */}
        {!hideMenu && <DashboardButton dashboardVisible={false} onClick={(): void => toggleDashboard()} />}

        {/* Remote */}
        <Remote />
      </div>

      {/* Dashboard */}
      {dashboardOpened && (menu?.categories?.length ? <Dashboard toggleDashboard={(): void => toggleDashboard(true)} /> : <OldDashboard toggleDashboard={(): void => toggleDashboard(true)} />)}
    </React.Fragment>
  )
}

export default RemoteContainer
